import React from 'react';
import PropTypes from "prop-types";
import { InputLabel, MenuItem, FormControl, Select }  from '@mui/material';

export default class ExtraLetters extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
  };

  render() {
    const options = Array(3).fill(null).map((step, value) => {
      const name = (value === 0) ? "No" : value;
      const s = (value === 1) ? "" : "s";
      return (
        <MenuItem key={value} value={value}>{name} Extra Letter{s}</MenuItem>
      );
    });

    return (
      <FormControl>
        <InputLabel htmlFor="extra-letters-select">Extra Letters</InputLabel>
        <Select typography="body1" value={this.props.value} onChange={this.props.onChange} inputProps={{ id: "extra-letters-select" }}>
          {options}
        </Select>
      </FormControl>
    );
  }
}

